import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/locationGroups'
import Component from 'components/LocationGroups'

export default createListViewContainer({ actions, selectors: selectors.locationGroups })(Component)
